import { APICore } from '../../helpers/api/apiCore';
import * as URL from "../../helpers/api/apiEndPoint"

const api = new APICore();

function commodityCategory(params: any): any {
    const { search, limit, pages, status } = params.data
    return api.get(`${URL.COMMODITY_CATEGORY_GET}search=${encodeURIComponent(search)}&limit=${limit}&page=${pages}&status=${status}`);
}

function createCommodityCategory(params: any): any {
    const { data } = params
    return api.create(URL.COMMODITY_CATEGORY_POST, data);
}

function updateCommodityCategory(params: any): any {
    const { data } = params
    return api.update(URL.COMMODITY_CATEGORY_UPDATE, data);
}

function deleteCommodityCategory(params: any): any {
    const { data } = params;
    return api.delete(`${URL.COMMODITY_CATEGORY_DELETE}_id=${data?.id}`);
}

export { commodityCategory, createCommodityCategory, updateCommodityCategory, deleteCommodityCategory }
